export class EmployeeDto {
    public id: number | undefined = undefined;    
    public firstName: string | undefined = undefined;
    public lastName: string | undefined = undefined;
    public phoneNumber: string | undefined = undefined;
    public email: string | undefined = undefined;
}